<template>
  <div class="admin admin-public-part-lot">
    <div v-if="foundItems !== undefined">
      <form class="a-sort" action="">
        <p class="a-sort__see">
          {{$tc('form.lot-search.search-result', foundItems)}}
        </p>
      </form>
      <div class="a-сard-admin">
        <div class="a-сard-admin__block" v-for="item in items">
          <div class="a-сard-admin__body">
            <div class="a-сard-admin__content-text">
              <div class="a-сard-admin__label">{{$t('form.lot.name')}}: </div>
              <p class="a-сard-admin__text">{{item.name}}</p>
            </div>
            <div class="a-сard-admin__content-text">
              <div class="a-сard-admin__label">{{$t('labels.lot-status')}}: </div>
              <p class="a-сard-admin__text">{{$t(item.state.label)}}</p>
            </div>
            <div class="a-сard-admin__content-text">
              <div class="a-сard-admin__label">{{$t('form.lot.publish-date')}}: </div>
              <date-time class="a-сard-admin__text" :value="item.published" :time="false"></date-time>
            </div>
            <div class="a-сard-admin__content-text">
              <div class="a-сard-admin__label">{{$t('form.lot.application-completion-date')}}:</div>
              <date-time class="a-сard-admin__text" :value="item.endGettingReq" :time="false"></date-time>
            </div>
            <div class="a-сard-admin__content-text">
              <div class="a-сard-admin__label">{{$t('form.lot.owner')}}:</div>
              <p class="a-сard-admin__text">{{item | fullName}} </p>
            </div>
            <div class="a-сard-admin__content-text">
              <p class="a-сard-admin__text" style="color:#E30613" v-if="item.invite">{{$t('form.lot.you-are-invited')}}</p>
            </div>

            <div class="a-сard-admin__btn-block">
              <router-link tag="button"
                           class="gui-btn gui-btn--order"
                           :to="{name: 'purchases-my-lots-details', params: { lotId: item.id, tab: 'overview'}}">
                {{$t('buttons.open-public-lot')}}
              </router-link>
            </div>
          </div>
        </div>
        <button class="gui-btn gui-btn--more u-margin-24-auto" @click.prevent="fetchMoreFavorites" v-if="foundItems !== items.length">{{$t('buttons.show-more')}}</button>
      </div>
      <loading v-if="loading"></loading>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      foundItems() { return this.$store.state.search.favorites.total },
      items() { return this.$store.state.search.favorites.items },

      isAuthorized() {
        return this.$store.state.isAuthorized;
      }
    },

    created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchFavorites', {})
        }
        catch (e) {
          console.error('failed fetching favorites lots', e);
          this.globalErrorHandler(e);
        }
      });
    },

    methods: {
      async fetchMoreFavorites() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('fetchMoreFavorites');
          }
          catch(e) {
            console.error('failed fetching more favorites lots', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>
</style>
